import type { PharmacyOverride } from '../hooks/use-config-api';

export const PHARMACY_NPIS = {
    AMAZON: '1285084467',
    AMAZON_OLD: '1912499500',
    FUZE_HEALTH: '1295182590',
    GIFTHEALTH: '1689411712',
    LILLYDIRECT: '1912889320',
} as const;

const giftHealth: PharmacyOverride = {
    npi: PHARMACY_NPIS.GIFTHEALTH,
    name: 'LillyDirect powered by Gifthealth Pharmacy',
    logoUrl: '/static/img/lilly-gifthealth-logo.svg',
    logoWidth: 121,
    nextStepsDescription:
        'We have sent your prescription to our pharmacy services provider, LillyDirect powered by Gifthealth Pharmacy. They will be in contact via text or email within 1 business day with the next steps.',
    phone: '1-833-707-6619',
    url: 'https://gifthealth.com',
    contactTime: '1 business day',
    shippingTime: '1-3 business days',
    deliveryDays: '1-3',
};

const amazon: PharmacyOverride = {
    npi: PHARMACY_NPIS.AMAZON,
    name: 'Amazon Pharmacy',
    logoUrl: '/static/img/amazon-pharmacy-logo.svg',
    logoWidth: 210,
    nextStepsDescription:
        'We have sent your prescription to our pharmacy services provider, Amazon Pharmacy. They will send you a notification once the prescription is ready to purchase.',
    phone: '855-681-6802',
    url: 'https://pharmacy.amazon.com',
    contactTime: '1 hour',
    shippingTime:
        '1-2 days nationwide; same-day delivery available in eligible zip-codes',
    deliveryDays: '1-3',
};

export const pharmacyOverrides: Record<string, PharmacyOverride> = {
    '1574056': {
        name: 'LillyDirect Pharmacy',
        npi: PHARMACY_NPIS.LILLYDIRECT,
        logoUrl: '',
        logoWidth: -1,
        phone: '',
        url: '',
        contactTime: '',
        shippingTime: '',
    },
    '3692539': giftHealth,
    '3688833': giftHealth,
    '5660091': {
        npi: PHARMACY_NPIS.FUZE_HEALTH,
        name: 'LillyDirect powered by Fuze Health',
        logoUrl: '/static/img/lilly-fuze-health-logo.jpg',
        logoWidth: 210,
        nextStepsDescription:
            'We have sent your prescription to our pharmacy services provider, LillyDirect powered by Fuze Health. They will be in contact via text or email within 1-2 hours with the next steps.',
        phone: '800-398-8199',
        url: 'https://lillydirect.fuzehealth.com/faq',
        contactTime: '1-2 hours',
        shippingTime: '1-3 business days',
        deliveryDays: '1-3',
    },
    '5919177': amazon,
    '8899558': {
        ...giftHealth,
        npi: '1234567891',
    },
    '9898981': {
        ...giftHealth,
        npi: '1234567891',
    },
    '9898987': {
        ...giftHealth,
        npi: '1000107429',
    },
    '0362309': {
        ...amazon,
        npi: PHARMACY_NPIS.AMAZON_OLD,
    },
};
